export default "../media/bg_careers_1_large.798055458809a48cb222ef4c3a9654e9.jpeg";